import useTranslate from 'hooks/useTranslate';
import { useEffect, useState } from 'react';
import { Row, Tab, Tabs, Container } from 'react-bootstrap';
import { TemplateCardSkeleton } from 'components/Common/Skeleton/Resume';
import TemplateCard from 'components/ResumeBuilder/TemplateCard';
import TemplatePreview from 'components/ResumeBuilder/TemplatePreview';
import { useGetDownloadResumeQuery, useGetTemplateListQuery } from 'services';
import './styles.scss';

const ResumeTemplates = () => {
	// hooks
	const { translate } = useTranslate();

	// state
	const [showPreview, setShowPreview] = useState(false);
	const [selectedItem, setSelectedItem] = useState({});
	const [activeTab, setActiveTab] = useState('resumeTemplates');
	const [templateList, setTemplateList] = useState<any>([]);

	// mutation
	const { data: templatesData = {}, isLoading } = useGetTemplateListQuery();
	const { data: downloadedResumes, isLoading: isLoadingPdf } = useGetDownloadResumeQuery(
		activeTab == 'downloadedResumes',
	);
	const handleClose = () => {
		setShowPreview(false);
		setSelectedItem({});
	};

	const handleSelectTemplate = (item: any) => {
		setSelectedItem(item);
		setShowPreview(true);
	};

	const handleTabSelect = (tab: any) => {
		setActiveTab(tab);
	};

	useEffect(() => {
		if (templatesData && templatesData.length) {
			setTemplateList(templatesData);
		}
	}, [templatesData, activeTab]);

	return (
		<div className="resume-templates">
			<Container>
				<div className="resume-templates-heading mb-3 mb-sm-4">
					<h3 className="fw-bold">
						{translate('Header.resumeBuilder')}{' '}
						<span>{translate('Header.resumeBuilderTemplates')}</span>
					</h3>
					<p className="mb-0">{translate('Home.introJobStasSubTitle')}</p>
				</div>
				<Tabs
					defaultActiveKey="resumeTemplates"
					activeKey={activeTab}
					className="resume-templates-tabs mb-4 mb-lg-5"
					onSelect={handleTabSelect}
				>
					<Tab eventKey="resumeTemplates" title={translate('Resume.resumeTemplates')}>
						<div className="resume-templates-field">
							<Row>
								{isLoading ? (
									<TemplateCardSkeleton />
								) : (
									<>
										{templateList?.length ? (
											templateList.map((item: any) => {
												return (
													<TemplateCard
														key={item.id}
														data={item}
														handleClick={() => handleSelectTemplate(item)}
													/>
												);
											})
										) : (
											<div className="d-flex justify-content-center">
												{translate('Common.noDataFound')}
											</div>
										)}
									</>
								)}
							</Row>
						</div>
					</Tab>
					<Tab
						eventKey="downloadedResumes"
						title={<div>{translate('Template.downloadedResumes')}</div>}
					>
						<div className="resume-templates-field">
							<Row>
								{isLoadingPdf ? (
									<TemplateCardSkeleton />
								) : (
									<>
										{downloadedResumes?.length ? (
											downloadedResumes.map((item: any) => {
												return (
													<TemplateCard
														key={item.id}
														data={item}
														handleClick={() => handleSelectTemplate(item)}
														isDownloadedSection={activeTab === 'downloadedResumes'}
													/>
												);
											})
										) : (
											<div className="d-flex justify-content-center">
												{translate('Common.noResumeDownloaded')}
											</div>
										)}
									</>
								)}
							</Row>
						</div>
					</Tab>
				</Tabs>
				<TemplatePreview show={showPreview} handleClose={handleClose} data={selectedItem} />
			</Container>
		</div>
	);
};

export default ResumeTemplates;
